import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Divider,
  Grid,
  Typography
} from "@mui/material";
import { SxProps, Theme } from '@mui/material/styles';
import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { callAPI, Method } from "../../../commonFunctions/CommonFunctions";
import { WSIcons } from "../../../commonFunctions/iIcons";
import EditLabel from "../../../Components/EditLabel/EditLabel";
import { useParams } from 'react-router-dom';
const Sidebar: React.FC<any> = React.memo((props) => {
  const params = useParams();
  const [data, setData] = useState(props?.data || undefined);
  const { control, setValue } = useForm();
  const id = params?.id;
  const topLableFontSize = '0.875rem'
  const topDataFontSize = '0.75rem'
  const [relload, setReload] = useState(false);
  const accondianheaderFontSize = '0.75rem'
  const [leadStatusList, setLeadStatusList] = useState<any>([]);
  useEffect(() => {
    async function getLeadStatus() {
      const response = await callAPI("lead-status", Method.GET, null, null);
      if (response.length > 0) {
        const options: Array<any> = [];
        response.map((item: any) => {
          options.push({
            label: item.name,
            value: item.id,
          });
        });
        setLeadStatusList(options);
      }
    }
    getLeadStatus();
  }, []);
  useEffect(() => {
    
    async function getLeads() {
      const response: any = await callAPI('leads', Method.GET, null, id)
      if (response) {
      
        setData(response)
        setReload(false)
      }

    }
    if (relload && id) {
      getLeads();
    }
  }, [relload])
  // Define the state with specific keys
  const [sections, setSections] = useState<{
    about: boolean;
    communication: boolean;
    websiteActivity: boolean;
  }>({
    about: true,
    communication: true,
    websiteActivity: true,
  });
  const [expanded, setExpanded] = React.useState<string | false>("panel1");

  const handleChange =
    (panel: string) => (event: React.SyntheticEvent, newExpanded: boolean) => {
      setExpanded(newExpanded ? panel : false);
    };
  // Type 'section' to match the keys of 'sections'
  const toggleSection = (section: keyof typeof sections) => {
    setSections((prev) => ({ ...prev, [section]: !prev[section] }));
  };

  const reloadData = (reloadevt: boolean) => {
    if (reloadevt === true) {
      setReload(true)
    }
  }
  const fontStyle: SxProps<Theme> = {
    color: '#080763',
    fontSize: '0.9rem'

  }
  return (
    <Grid sx={{
      border: "1px solid #ddd",
      borderRadius: 2,
      width: '100%',
      // maxHeight: "500px", // Set the maximum height of the container
      overflowX: "hidden", // Disable horizontal scrolling
      overflowY: "hidden", // Enable vertical scrolling
    }} >
      {/* Header Section */}
      <Grid
        sx={{
          backgroundColor: "#7D79C2",
          color: "white",
          alignItems: "center",
          p: 1.5,

        }}
      >
        <Typography fontWeight="bold">
          <WSIcons.KeyboardDoubleArrowRightIcon />
        </Typography>
      </Grid>

      <Grid container spacing={2}>
        <Grid item sm={12} mt={1}>
          <Accordion
            expanded={expanded === "panel1"}
            onChange={handleChange("panel1")}
            sx={{
              mt: 2,
              border: "1px solid #CDCDCE",
              borderRadius: 3,
              margin: 1,
              overflow: "hidden",
              "&.Mui-expanded": {
                margin: 1,
              },
              "&:first-of-type": {
                borderRadius: 3, // Ensures the first accordion also gets rounded corners
              },
              "&:before": { display: "none" }, // Removes the default MUI divider
            }}
          >
            <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls="panel1d-content" id="panel1d-header">
              <Typography component="span" sx={fontStyle}>About this leads</Typography>

            </AccordionSummary>
            <Divider sx={{ marginBottom: 2 }} />
            <AccordionDetails sx={{ width: "19rem" }}>

              <>
                <Grid item xs={12}>
                  <Typography sx={{ fontSize: topLableFontSize }} color="textSecondary">
                    Email 
                  </Typography>
                  <EditLabel
                    labelSx={{ padding: 1, fontSize: topDataFontSize }}
                    label={""}
                    control={control}
                    id="text"
                    name="Email"
                    apiUrl={`/leads`}
                    updateId={data?.id}
                    text={data?.email || "-"}
                    setValue={setValue}
                    editType="email"
                    reloadData={reloadData}
                  />
                </Grid>
                <Grid item xs={12}>
                  <Typography sx={{ fontSize: topLableFontSize }} color="textSecondary">
                    Phone Number
                  </Typography>
                  <EditLabel
                    labelSx={{ padding: 1, fontSize: topDataFontSize }}
                    control={control}
                    id="Phone"
                    name="Phone"
                    setValue={setValue}
                    apiUrl={`/leads`}
                    updateId={data?.id}
                    text={data?.phone}
                    reloadData={reloadData}
                    editType="phone"
                  />
                </Grid>
                <Grid item xs={12}>
                  <Typography sx={{ fontSize: topLableFontSize }} color="textSecondary">
                    Mobile
                  </Typography>
                  <EditLabel
                    labelSx={{ padding: 1, fontSize: topDataFontSize }}
                    control={control}
                    id="Mobile"
                    name="Mobile"
                    setValue={setValue}
                    apiUrl={`/leads`}
                    updateId={data?.id}
                    text={data?.mobile}
                    reloadData={reloadData}
                    editType="phone"
                  />
                </Grid>
                <Grid item xs={12}>
                  <Typography sx={{ fontSize: topLableFontSize }} color="textSecondary">
                    First Name
                  </Typography>
                  <EditLabel
                    labelSx={{ padding: 1, fontSize: topDataFontSize }}
                    control={control}
                    id="FirstName"
                    name="FirstName"
                    setValue={setValue}
                    reloadData={reloadData}
                    apiUrl={`/leads`}
                    updateId={data?.id}
                    text={data?.firstName || "-"}
                    editType="text"
                  />
                </Grid>
                <Grid item xs={12}>
                  <Typography sx={{ fontSize: topLableFontSize }} color="textSecondary">
                    Last Name
                  </Typography>
                  <EditLabel
                    labelSx={{ padding: 1, fontSize: topDataFontSize }}
                    control={control}
                    id="LastName"
                    name="LastName"
                    setValue={setValue}
                    reloadData={reloadData}
                    apiUrl={`/leads`}
                    updateId={data?.id}
                    text={data?.lastName || "-"}
                    editType="text"
                  />
                </Grid>
                {/* <Grid item xs={12}>
                  <Typography sx={{ fontSize: topLableFontSize }} color="textSecondary">
                    Lead Owner
                  </Typography>
                  <EditLabel
                    labelSx={{ padding: 1, fontSize: topDataFontSize }}
                    control={control}
                    id="LeadOwner"
                    name="LeadOwner"
                    setValue={setValue}
                    reloadData={reloadData}
                    apiUrl={`/leads`}
                    updateId={data?.id}
                    text={data?.leadOwner || "-"}
                    editType="text"
                  />
                </Grid> */}
                <Grid item xs={12}>
                  <Typography sx={{ fontSize: topLableFontSize }} color="textSecondary">
                    Lead Source
                  </Typography>
                  <EditLabel
                    labelSx={{ padding: 1, fontSize: topDataFontSize }}
                    control={control}
                    id="LeadSource"
                    name="LeadSource"
                    setValue={setValue}
                    reloadData={reloadData}
                    options={[{ label: "SS", value: "SS" }]}
                    apiUrl={`/leads`}
                    updateId={data?.id}
                    text={data?.leadSource || "-"}
                    editType="dropdown"
                  />
                </Grid>
                <Grid item xs={12}>
                  <Typography sx={{ fontSize: topLableFontSize }} color="textSecondary">
                    Company
                  </Typography>
                  <EditLabel
                    labelSx={{ padding: 1, fontSize: topDataFontSize }}
                    control={control}
                    id="Company"
                    reloadData={reloadData}
                    name="Company"
                    setValue={setValue}
                    apiUrl={`/leads`}
                    updateId={data?.id}
                    text={data?.company || "-"}
                    editType="text"
                  />
                </Grid>
                <Grid item xs={12}>
                  <Typography sx={{ fontSize: topLableFontSize }} color="textSecondary">
                    Website
                  </Typography>
                  <EditLabel
                    labelSx={{ padding: 1, fontSize: topDataFontSize }}
                    control={control}
                    id="Website"
                    name="Website"
                    setValue={setValue}
                    reloadData={reloadData}
                    apiUrl={`/leads`}
                    updateId={data?.id}
                    text={data?.website || "-"}
                    editType="text"
                  />
                </Grid>
                <Grid item xs={12}>
                  <Typography sx={{ fontSize: topLableFontSize }} color="textSecondary">
                    Lead Status
                  </Typography>
                  <Typography sx={{ padding: 1, fontSize: topDataFontSize }}>{data?.leadStatus}</Typography>
                  {/* <EditLabel
                    labelSx={{ padding: 1 }}
                    control={control}
                    id="LeadStatus"
                    name="LeadStatus"
                    options={leadStatusList}
                    setValue={setValue}
                    apiUrl={`/leads/${data?.id}`}
                    text={data?.leadStatus || "-"}
                    editType="dropdown"
                  /> */}
                </Grid>
                <Grid item xs={12}>
                  <Typography sx={{ fontSize: topLableFontSize }} color="textSecondary">
                    Industry
                  </Typography>
                  <EditLabel
                    labelSx={{ padding: 1, fontSize: topDataFontSize }}
                    control={control}
                    id="Industry"
                    name="Industry"
                    setValue={setValue}
                    reloadData={reloadData}
                    apiUrl={`/leads`}
                    updateId={data?.id}
                    text={data?.industry || "-"}
                    editType="text"
                  />
                </Grid>
                {/* <Grid item xs={12}>
                  <Typography variant="body1" color="textSecondary">
                    Rating
                  </Typography>
                  <EditLabel
                   labelSx={{ padding: 1 }}
                    control={control}
                    id="rating"
                    name="rating"
                    setValue={setValue}
                    apiUrl={`/leads/${data?.id}`}
                    text={data?.rating || "-"}
                    editType="number"
                  />
                </Grid> */}

                {/* <Grid item xs={12}>
                  <Typography  variant="body1" color="textSecondary">
                    Create Date
                  </Typography>
                  <Typography   sx={{ padding: 1 }}>{dateFormat (data?.createdAt,"MMM D, YYYY")}</Typography>
                </Grid> */}
              </>
            </AccordionDetails>
          </Accordion>
          <Accordion
            expanded={expanded === "panel2"}
            onChange={handleChange("panel2")}
            sx={{
              mt: 2,
              border: "1px solid #CDCDCE",
              borderRadius: 3,
              margin: 1,
              overflow: "hidden",
              "&.Mui-expanded": {
                margin: 1,
              },

            }}
          >
            <AccordionSummary aria-controls="panel2d-content" expandIcon={<ExpandMoreIcon />}>
              <Typography component="span" sx={fontStyle}>Address Information</Typography>
            </AccordionSummary>
            <Divider sx={{ marginBottom: 2 }} />
            <AccordionDetails sx={{ width: "19rem" }}>
              <>
                <Grid item xs={12}>
                  <Typography sx={{ fontSize: topLableFontSize }} color="textSecondary">
                    Street
                  </Typography>
                  <EditLabel
                    labelSx={{ padding: 1, fontSize: topDataFontSize }}
                    control={control}
                    id="Street"
                    name="Street"
                    setValue={setValue}
                    reloadData={reloadData}
                    apiUrl={`/leads`}
                    updateId={data?.id}
                    text={data?.street || "-"}
                    editType="text"
                  />
                </Grid>
                <Grid item xs={12}>
                  <Typography sx={{ fontSize: topLableFontSize }} color="textSecondary">
                    City
                  </Typography>
                  <EditLabel
                    labelSx={{ padding: 1, fontSize: topDataFontSize }}
                    control={control}
                    id="City"
                    name="City"
                    setValue={setValue}
                    reloadData={reloadData}
                    apiUrl={`/leads`}
                    updateId={data?.id}
                    text={data?.city || "-"}
                    editType="text"
                  />
                </Grid>
                <Grid item xs={12}>
                  <Typography sx={{ fontSize: topLableFontSize }} color="textSecondary">
                    State
                  </Typography>
                  <EditLabel
                    labelSx={{ padding: 1, fontSize: topDataFontSize }}
                    control={control}
                    id="State"
                    name="State"
                    setValue={setValue}
                    reloadData={reloadData}
                    apiUrl={`/leads`}
                    updateId={data?.id}
                    text={data?.state || "-"}
                    editType="text"
                  />
                </Grid>
                <Grid item xs={12}>
                  <Typography sx={{ fontSize: topLableFontSize }} color="textSecondary">
                    Country
                  </Typography>
                  <EditLabel
                    labelSx={{ padding: 1, fontSize: topDataFontSize }}
                    control={control}
                    id="Country"
                    name="Country"
                    setValue={setValue}
                    reloadData={reloadData}
                    apiUrl={`/leads`}
                    updateId={data?.id}
                    text={data?.country || "-"}
                    editType="text"
                  />
                </Grid>
                <Grid item xs={12}>
                  <Typography sx={{ fontSize: topLableFontSize }} color="textSecondary">
                    ZipCode
                  </Typography>
                  <EditLabel
                    labelSx={{ padding: 1, fontSize: topDataFontSize }}
                    control={control}
                    id="ZipCode"
                    name="ZipCode"
                    setValue={setValue}
                    reloadData={reloadData}
                    apiUrl={`/leads`}
                    updateId={data?.id}
                    text={data?.zipCode || "-"}
                    editType="text"
                  />
                </Grid>

                {/* <Grid item xs={12}>
                    <Typography variant="body1" color="textSecondary">
                      {" "}
                      Use subscription types to manage the communications this contact
                      receives from you
                    </Typography>
                  </Grid>
                  <Grid item xs={12} sm={10}>
                    <Typography
                      variant="subtitle2"
                      sx={{ fontWeight: "bold", color: "lightblue" }}
                    >
                      View Subscriptions
                    </Typography>
                  </Grid> */}
              </>
            </AccordionDetails>
          </Accordion>
          <Accordion
            expanded={expanded === "panel3"}
            onChange={handleChange("panel3")}
            sx={{
              mt: 2,
              border: "1px solid #CDCDCE",
              borderRadius: 3,
              margin: 1,
              overflow: "hidden",
              "&.Mui-expanded": {
                margin: 1,
              },
              "&:last-of-type": {
                borderRadius: 3, // Ensures the first accordion also gets rounded corners
              },
              "&:before": { display: "none" },
            }}
          >
            <AccordionSummary aria-controls="panel3d-content" id="panel3d-header" expandIcon={<ExpandMoreIcon />}>
              <Typography component="span" sx={fontStyle}>Remarks</Typography>
            </AccordionSummary>
            <Divider sx={{ marginBottom: 2 }} />
            <AccordionDetails sx={{ width: "19rem" }}>
              <>
                <Grid item xs={12}>
                  <Typography sx={{ fontSize: topLableFontSize }} color="textSecondary">
                    Remarks
                  </Typography>
                  <EditLabel
                    labelSx={{ padding: 1, fontSize: topDataFontSize }}
                    control={control}
                    id="Remarks"
                    name="Remarks"
                    setValue={setValue}
                    apiUrl={`/leads`}
                    updateId={data?.id}
                    text={data?.remarks || "-"}
                    editType="text"
                  />
                </Grid>
              </>
            </AccordionDetails>
          </Accordion>
        </Grid>
      </Grid>
    </Grid>
  );
});

export default Sidebar;
